<template>
  <Transition name="slide-down">
    <div v-if="isVisible" class="workload-blocked-banner">
      <div class="workload-blocked-banner__container">
        <div class="workload-blocked-banner__icon">
          <Icon
            :name="isFullyBlocked ? 'heroicons:no-symbol' : 'heroicons:truck'"
            class="w-5 h-5"
          />
        </div>

        <div class="workload-blocked-banner__content">
          <div class="workload-blocked-banner__title">
            <Icon name="heroicons:exclamation-triangle" class="w-4 h-4 inline mr-1" />
            {{ title }}
          </div>
          <div v-if="subtitle" class="workload-blocked-banner__subtitle">
            {{ subtitle }}
          </div>
        </div>
      </div>
    </div>
  </Transition>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { useBranchAvailability } from '@entities/institution'

const availability = useBranchAvailability()

const isFullyBlocked = computed(() => availability.isFullyBlocked.value)
const isDeliveryOnlyBlocked = computed(
  () => !isFullyBlocked.value && availability.deliveryStopped.value,
)
const isVisible = computed(() => isFullyBlocked.value || isDeliveryOnlyBlocked.value)

const title = computed(() => {
  if (isFullyBlocked.value) return 'Заведение временно не принимает заказы'
  if (isDeliveryOnlyBlocked.value) return 'Доставка временно остановлена'
  return ''
})

const subtitle = computed(() => {
  if (isFullyBlocked.value) return 'Попробуйте оформить заказ чуть позже'
  if (isDeliveryOnlyBlocked.value) return 'Доступны самовывоз и заказ в зале'
  return ''
})
</script>

<style scoped lang="scss">
.workload-blocked-banner {
  @apply
    relative
    bg-gradient-to-r from-orange-500 via-red-500 to-pink-500
    dark:from-orange-600 dark:via-red-600 dark:to-pink-600
    text-white shadow-xl border-b-2 border-orange-300/50
    dark:border-orange-400/30 overflow-hidden;

  &__container {
    @apply
      max-w-7xl mx-auto px-4 sm:px-6 lg:px-8
      py-3 flex items-center justify-center gap-3 relative z-10;
  }

  &__icon {
    @apply
      flex-shrink-0 text-white
      bg-white/20 rounded-full p-2.5
      dark:bg-white/15 shadow-lg
      border border-white/30 flex items-center justify-center;
  }

  &__content {
    @apply flex flex-col flex-1 min-w-0 text-center;
  }

  &__title {
    @apply
      flex items-center justify-center
      text-sm font-bold text-white
      drop-shadow-sm;
  }

  &__subtitle {
    @apply
      flex items-center justify-center
      text-xs text-white/95 font-medium drop-shadow-sm mt-0.5;
  }
}

.slide-down-enter-active,
.slide-down-leave-active {
  transition: all 0.3s ease-in-out;
}

.slide-down-enter-from {
  transform: translateY(-100%);
  opacity: 0;
}

.slide-down-leave-to {
  transform: translateY(-100%);
  opacity: 0;
}

@media (max-width: 640px) {
  .workload-blocked-banner {
    &__container {
      @apply px-3 py-2 gap-2;
    }
    &__title {
      @apply text-xs;
    }
    &__subtitle {
      @apply text-xs;
    }
  }
}
</style>
